/*jshint esversion: 6 */
(function () {
	'use strict';
	$(function () {

		var map, columnChart;
		var isMobileView = false;
		isMobileView = $(".chart").width() < 550;

		var regions = {
			latin: {
				serie: "Latin America and the Caribbean",
				selected: false,
				selectedColor: "#80bba1",
				countries: ["AR", "AW", "BB", "BZ", "BO", "BR", "CL", "CO", "CR", "CW", "DO", "EC", "SV", "GT", "GY", "HT", "HN", "JM", "MX", "NI", "PA", "PY", "PE", "SR", "TT", "UY", "VE",],
				tooltip: "<h3>Latin America and the Caribbean:</h3>" +
					"<p>Weighted Small/Medium - Av. Overall score:<br><strong>44.3</strong></p>" +
					"<p>Weighted Large - Av. Overall score:<br><strong>39</strong></p>" +
					"<p>Best performing:<br><strong>Brazil - Manufacture of pulp, paper and paperboard</strong></p>"
			},
			africaMiddleEast: {
				serie: "Africa and the Middle East",
				selected: false,
				selectedColor: "#ff0000",
				countries: ["DZ", "AO", "BJ", "BW", "BF", "BI", "CD", "CM", "CV", "CF", "KM", "CG", "CI", "DJ", "EG", "GQ", "ER", "ET", "GA", "GM", "GH", "GN", "GW", "KE", "LS", "LR", "LY", "MG", "MW", " MV", "ML", "MR", "MU", "YT", "MA", "MZ", "NA", "NE", "NG", "RE", "RW", "SH", "ST", "SN", "SC", "SL", "SO", "ZA", "SD", "SZ", "TD", "TZ", "TG", "TN", "UG", "EH", "ZR", "ZM", "ZW", "AM", "AZ", "BH", "GE", "IR", "IQ", "IL", "JO", "KW", "LB", "NT", "OM", "QA", "SA", "SY", "TR", "AE", "YE"],
				tooltip: "<h3>Africa and the Middle East:</h3>" +
					"<p>Weighted Small/Medium - Av. Overall score:<br><strong>99.9</strong></p>" +
					"<p>Weighted Large - Av. Overall score:<br><strong>52.11</strong></p>" +
					"<p>Best performing:<br><strong>Belgium - Manufacture of pulp, paper and paperboard</strong></p>"
			},
			europe: {
				serie: "Europe",
				selected: false,
				selectedColor: "#00c43c",
				countries: ["AL", "AD", "AT", "BE", "BA", "BG", "BY", "HR", "CY", "CZ", "DK", "EE", "FO", "FI", "FR", "DE", "GI", "GR", "HU", "IS", "IE", "IT", "LV", "LI", "LT", "LU", "MT", "MD", "MC", "NL", "NO", "PL", "PT", "RO", "RU", "SM", "SK", "ES", "SJ", "SE", "UA", "GB", "VA"],
				tooltip: "<h3>Europe:</h3>" +
					"<p>Weighted Small/Medium - Av. Overall score:<br><strong>52.3</strong></p>" +
					"<p>Weighted Large - Av. Overall score:<br><strong>52.11</strong></p>" +
					"<p>Best performing:<br><strong>Belgium - Manufacture of pulp, paper and paperboard</strong></p>"
			},
			asiaPacific: {
				serie: "Asia Pacific",
				selected: false,
				selectedColor: "#0000ff",
				countries: ["AF", "BD", "BT", "IO", "BN", "KH", "CN", "TP", "GU", "HK", "IN", "ID", "JP", "KZ", "KP", "KR", "KG", "LA", "MO", "MY", "MV", "MN", "MM", "NR", "NP", "MP", "PK", "PW", "PH", "SG", "LK", "TJ", "TW", "TH", "TM", "SU", "UZ", "VN", "AS", "AU", "CX", "CC", "CK", "FJ", "PF", "TF", "HM", "ID", "KI", "MH", "FM", "NR", "NC", "NZ", "NU", "NF", "PW", "PG", "PN", "WS", "SB", "TK", "TO", "TV", "UM", "VU", "WF"],
				tooltip: "<h3>Asia-Pacific:</h3>" +
					"<p>Weighted Small/Medium - Av. Overall score:<br><strong>88.8</strong></p>" +
					"<p>Weighted Large - Av. Overall score:<br><strong>52.11</strong></p>" +
					"<p>Best performing:<br><strong>Belgium - Manufacture of pulp, paper and paperboard</strong></p>"
			},
			northAmerica: {
				serie: "Northern America",
				selected: false,
				selectedColor: "#00a6fb",
				countries: ["CA", "US"],
				tooltip: "<h3>Northern America:</h3>" +
					"<p>Weighted Small/Medium - Av. Overall score:<br><strong>47.3</strong></p>" +
					"<p>Weighted Large - Av. Overall score:<br><strong>44.4</strong></p>" +
					"<p>Best performing:<br><strong>United States of America - Manufacture of pulp, paper and paperboard</strong></p>"
			},
			world: {
				serie: "world",
				selected: false,
				selectedColor: "#0000ff",
				countries: ["AR", "AW", "BB", "BZ", "BO", "BR", "CL", "CO", "CR", "CW", "DO", "EC", "SV", "GT", "GY", "HT", "HN", "JM", "MX", "NI", "PA", "PY", "PE", "SR", "TT", "UY", "VE", "DZ", "AO", "BJ", "BW", "BF", "BI", "CM", "CV", "CF", "KM", "CG", "CI", "DJ", "EG", "GQ", "ER", "ET", "GA", "GM", "GH", "GN", "GW", "KE", "LS", "LR", "LY", "MG", "MW", " MV", "ML", "MR", "MU", "YT", "MA", "MZ", "NA", "NE", "NG", "RE", "RW", "SH", "ST", "SN", "SC", "SL", "SO", "ZA", "SD", "SZ", "TZ", "TG", "TN", "UG", "EH", "ZR", "ZM", "ZW", "AM", "AZ", "BH", "GE", "IR", "IQ", "IL", "JO", "KW", "LB", "NT", "OM", "QA", "SA", "SY", "TR", "TM", "AE", "YE", "AL", "AD", "AT", "BE", "BA", "BG", "BY", "HR", "CY", "CZ", "DK", "EE", "FO", "FI", "FR", "DE", "GI", "GR", "HU", "IS", "IE", "IT", "LV", "LI", "LT", "LU", "MT", "MD", "MC", "NL", "NO", "PL", "PT", "RO", "RU", "SM", "SK", "ES", "SJ", "SE", "TR", "UA", "GB", "VA", "AF", "BD", "BT", "IO", "BN", "KH", "CN", "TP", "GU", "HK", "IN", "ID", "JP", "KZ", "KP", "KR", "KG", "LA", "MO", "MY", "MV", "MN", "MM", "NR", "NP", "MP", "PK", "PW", "PH", "RU", "SG", "LK", "TJ", "TW", "TH", "TM", "SU", "UZ", "VN", "AS", "AU", "CX", "CC", "CK", "FJ", "PF", "TF", "HM", "ID", "KI", "MH", "FM", "NR", "NC", "NZ", "NU", "NF", "PW", "PG", "PN", "WS", "SB", "TK", "TO", "TV", "UM", "VU", "WF", "CA", "US"],
				tooltip: "<h3>World:</h3>" +
					"<p>Weighted Small/Medium - Av. Overall score:<br><strong>77.7</strong></p>" +
					"<p>Weighted Large - Av. Overall score:<br><strong>52.11</strong></p>" +
					"<p>Best performing:<br><strong>Belgium - Manufacture of pulp, paper and paperboard</strong></p>"
			},
		};

		var graphs = [{
			"balloonText": "<span style='font-size:12px;'>[[title]] in [[category]]:<br><span style='font-size:14px;'>[[value]]</span> [[additional]]</span>",
			"title": "World Large",
			"type": "column",
			"fillAlphas": 1,
			"valueField": "World L",
			// "fillColors": "#00C43C",
			// "lineColor": "#00C43C"
			"fixedColumnWidth": isMobileView ? 10 : 20
		}, {
			"balloonText": "<span style='font-size:12px;'>[[title]] in [[category]]:<br><span style='font-size:14px;'>[[value]]</span> [[additional]]</span>",
			"title": "World Small/Medium",
			"type": "column",
			"fillAlphas": 1,
			"valueField": "World SM",
			// "fillColors": "#00a6fb",
			// "lineColor": "#00a6fb"
			"fixedColumnWidth": isMobileView ? 10 : 20
		}];

		var columnChartData = [
			{
				"category": "Overall",
				"Latin America and the Caribbean L": 39.6,
				"Latin America and the Caribbean SM": 45.7,
				"Africa and the Middle East L": 38.1,
				"Africa and the Middle East SM": 42.4,
				"Europe L": 53.5,
				"Europe SM": 53.8,
				"Asia Pacific L": 40.1,
				"Asia Pacific SM": 41.8,
				"Northern America L": 44.3,
				"Northern America SM": 49.7,
				"World L": 47.2,
				"World SM": 49.6
			}, {
				"category": "Environment",
				"Latin America and the Caribbean L": 42.1,
				"Latin America and the Caribbean SM": 45.2,
				"Africa and the Middle East L": 42,
				"Africa and the Middle East SM": 42.6,
				"Europe L": 57.9,
				"Europe SM": 53.9,
				"Asia Pacific L": 44,
				"Asia Pacific SM": 43,
				"Northern America L": 45.2,
				"Northern America SM": 43.3,
				"World L": 50.6,
				"World SM": 49.3
			}, {
				"category": isMobileView ? "Labor<br>& Human<br>Rights" : "Labor<br>& Human Rights",
				"Latin America and the Caribbean L": 42.5,
				"Latin America and the Caribbean SM": 49.8,
				"Africa and the Middle East L": 41.5,
				"Africa and the Middle East SM": 46.4,
				"Europe L": 55.8,
				"Europe SM": 56.8,
				"Asia Pacific L": 42.5,
				"Asia Pacific SM": 45.8,
				"Northern America L": 45.6,
				"Northern America SM": 53.3,
				"World L": 49.4,
				"World SM": 53.2
			}, {
				"category": "Ethics",
				"Latin America and the Caribbean L": 39.2,
				"Latin America and the Caribbean SM": 43.1,
				"Africa and the Middle East L": 35.8,
				"Africa and the Middle East SM": 39.2,
				"Europe L": 50.9,
				"Europe SM": 51.6,
				"Asia Pacific L": 36.3,
				"Asia Pacific SM": 36.4,
				"Northern America L": 47.9,
				"Northern America SM": 48.3,
				"World L": 45.7,
				"World SM": 47
			}, {
				"category": "Sustainable<br>Procurement",
				"Latin America and the Caribbean L": 29.9,
				"Latin America and the Caribbean SM": 35.8,
				"Africa and the Middle East L": 27.6,
				"Africa and the Middle East SM": 32,
				"Europe L": 43.2,
				"Europe SM": 42.9,
				"Asia Pacific L": 32.2,
				"Asia Pacific SM": 32.4,
				"Northern America L": 35.5,
				"Northern America SM": 36.5,
				"World L": 37.9,
				"World SM": 39
			},
		];

		$(document).ready(function () {
			if (!$('.region-comparison').length) return;

			map = initMap();
			columnChart = initColumns();

			showChartTooltip(1, 5000);
			showChartTooltip(2, 10000);
			showChartTooltip(0, 15000);

			var currentUrl = new Url();
			if (currentUrl.query.regions) {
				if (Array.isArray(currentUrl.query.regions)) {
					for (var region of currentUrl.query.regions) {
						$(".region-checkboxes input[value='" + region + "']").prop("checked", true);
						addRegion(region, true);
					}
				} else {
					$(".region-checkboxes input[value='" + currentUrl.query.regions + "']").prop("checked", true);
					addRegion(currentUrl.query.regions, true);
				}
				rebuildDescriptions();
			}

			$(".region-checkboxes input").change(function (e) {
				//map.selectObject(map.getObjectById($(this).val()));
				addRegion($(this).val(), true);
				rebuildDescriptions();
			});

			$('.chart-tooltip').on('click', function () {
				$('.chart-tooltip').each(function () {
					$(this).fadeOut(1000);
				});
			});
		});

		function showChartTooltip(index, timeout) {
			setTimeout(function () {
				$('.chart-tooltip').eq(index).fadeIn(1000);
			}, timeout);
		}

		function addRegion(countryId, isRegion = false) {
			for (var region in regions) {
				regions[region].selected = false;
			}
			if (isRegion) {
				regions[countryId].selected = !regions[countryId].selected;
			} else {
				for (var region in regions) {
					if (region === "world") continue;
					if (regions[region].countries.indexOf(countryId) !== -1) {
						if (regions[region].selected) {
							regions[region].selected = false;
							$(".region-checkboxes input[value='" + region + "']").prop('checked', false);
						} else {
							regions[region].selected = true;
							$(".region-checkboxes input[value='" + region + "']").prop('checked', true);
						}
					}
				}
			}
			for (var region in regions) {
				if (regions[region].selected) {
					graphs[2] = {
						"balloonText": "<span style='font-size:12px;'>[[title]] in [[category]]:<br><span style='font-size:14px;'>[[value]]</span> [[additional]]</span>",
						"title": regions[region].serie + " Small/Medium",
						"type": "column",
						"fillAlphas": 1,
						"valueField": regions[region].serie + " SM",
						// "fillColors": "#FFB402",
						// "lineColor": "#FFB402"
						"fixedColumnWidth": isMobileView ? 10 : 20,
					};
					graphs[3] = {
						"balloonText": "<span style='font-size:12px;'>[[title]] in [[category]]:<br><span style='font-size:14px;'>[[value]]</span> [[additional]]</span>",
						"title": regions[region].serie + " Large",
						"type": "column",
						"fillAlphas": 1,
						"valueField": regions[region].serie + " L",
						// "fillColors": "#42AD88",
						// "lineColor": "#42AD88"
						"fixedColumnWidth": isMobileView ? 10 : 20,
					};
					//console.log(regions[region].selectedColor);
					changeChartTitle();
					columnChart.graphs = graphs;
					columnChart.validateData();
					columnChart.animateAgain();
				}
			}
		}

		function rebuildDescriptions() {
			deselectAllCountries();

			var sideContainer = $('.chart-with-side .side');
			sideContainer.html("");

			for (var region in regions) {
				if (regions[region].selected) {
					var regionHtml = "<div class='region'>" + regions[region].tooltip + "</div>";
					sideContainer.append(regionHtml);

					var countriesInRegion = regions[region].countries;
					for (var i = 0; i < countriesInRegion.length; i++) {
						selectCountry(countriesInRegion[i]);
					}
				}
			}
		}

		function deselectAllCountries() {
			for (var region in regions) {
				var countriesInRegion = regions[region].countries;

				for (var i = 0; i < countriesInRegion.length; i++) {
					var countryOnMap = map.getObjectById(countriesInRegion[i]);
					countryOnMap.showAsSelected = false;
					try {
						map.returnInitialColor(countryOnMap);
					} catch (e) {

					}
				}
			}
		}

		function selectCountry(country) {
			map.selectedObject = map.dataProvider;
			var countryOnMap = map.getObjectById(country);
			countryOnMap.showAsSelected = true;
			map.returnInitialColor(countryOnMap);
		}

		function changeChartTitle() {
			var newTitle = $("input[name=regions]:checked").parent().text();
			columnChart.allLabels[0].text = newTitle;
			columnChart.allLabels[0].fontSize = 18;
		}

		function initColumns() {
			return AmCharts.makeChart("region-column-chart", {
				"titles": [
					{
						"text": ".",
						"size": 28,
						"color": "transparent"
					}
				],
				"allLabels": [{
					"text": "",
					"bold": true,
					"x": 0,
					"y": 0,
					"rotation": 0,
					"align": "left",
					"size": 18,
					"color": "#4A4A49"
				}, {
					"text": "(Hover over the chart to view the values)",
					"bold": false,
					"x": 0,
					"y": 25,
					"rotation": 0,
					"align": "left",
					"size": 14,
					"color": "#4A4A49"
				}],
				"type": "serial",
				"theme": "light",
				"colors": ["#5CD982", "#FFCC50", "#00A6FB", "#FF6A4C", "#A6A6A6", "#660099"],
				"balloon": {
					"horizontalPadding": 10,
					"verticalPadding": 8,
				},
				"legend": {
					"position": "bottom",
					"fontSize": 12
				},
				"dataProvider": columnChartData,
				"graphs": graphs,
				"categoryAxis": {
					"gridPosition": "start",
					"axisColor": "#d9d9d9",
					"axisThickness": 2,
					"fontSize": 10
				},
				"valueAxes": [{
					"position": "left",
					"axisColor": "#d9d9d9",
					"color": "#4A4A49",
					"tickLength": 2,
					"labelFrequency": 2,
					"autoGridCount": false,
					"fontSize": 12
				}],
				"categoryField": "category",
				"startEffect": 'easeOutSine',
				"startDuration": 1,
				"sequencedAnimation": true,
				"chartCursor": {
					"enabled": true
				},
				"numberFormatter": {
					"precision": 1
				},
				// "guides": [
				// 	{
				// 		"fillAlpha": 0.4,
				// 		"label": 53,
				// 		"value": 53,
				// 		"toValue": 53,
				// 		"dashLength": 3,
				// 		"color": "#4A4A49",
				// 		"LabelColor": "#4A4A49",
				// 		"lineThickness": 2,
				// 		"boldLabel": true
				// 	}
				// ],
				"export": {
					"enabled": true,
					"menu": [{
						"class": "export-custom",
						"format": "JPG",
						"label": "Download the View",
						"title": "Export chart to JPG",
					}],
					"beforeCapture": function (menuConfig) {
						var url = "data:image/png;base64,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";
						var setup = this.setup;
						var timer = setInterval(function () {
							if (setup.fabric) {
								var canvas = setup.fabric;
								clearTimeout(timer);
								canvas.setOverlayImage(url, canvas.renderAll.bind(canvas), {
									scaleX: 1,
									scaleY: 1,
									top: 70,
									left: 60,
									originX: 'left',
									originY: 'top',
								});
							}
						}, 100);
					}
				},
				"responsive": {
					"enabled": true,
					"rules": [{
						"maxWidth": 550,
						"overrides": {
							"labelsEnabled": false,
							"legend": {
								"enabled": true,
								"position": "bottom",
								"fontSize": 8,
							},
							"fontSize": 8,
							"rotate": 90,
							"categoryAxis": {
								"fontSize" : 8,
							},
							"valueAxes": {
								"fontSize" : 8
							},
							"export": {
								"enabled": false,
								"menu": false,
							},
						}
					}]
				},
				"creditsPosition": "top-right"
			});
		}

		function initMap() {

			var areas = [];
			for (var region in regions) {
				if(region === "world") continue;
				for (var country in regions[region].countries) {
					areas.push({
						id: regions[region].countries[country],
						groupId: region,
						// customData: regions[region].tooltip,
						selectedColor: "#00c43c"
					});
				}
			}

			var map = AmCharts.makeChart("chart-map", {
				"type": "map",
				"theme": "light",
				"dataProvider": {
					"map": "worldHigh",
					"zoomLevel": 1,
					"zoomLongitude": 10,
					"zoomLatitude": 52,
					"areas": areas
				},

				"dragMap": false,

				"zoomControl": {
					"homeButtonEnabled": false,
					"zoomControlEnabled": false,
					"panControlEnabled": false,
				},

				"areasSettings": {
					"outlineThickness": 0,
					"outlineAlpha": 1,
					"outlineColor": 'transparent',
					"rollOverOutlineThickness": 0,
					"rollOverOutlineAlpha": 1,
					"rollOverOutlineColor": "transparent",
					"selectedOutlineThickness": 0,
					"selectedOutlineAlpha": 1,
					"selectedOutlineColor": "transparent",
					"unlistedOutlineThickness": 0,
					"unlistedOutlineAlpha": 1,
					"unlistedOutlineColor": "transparent",
					"rollOverColor": "#e9e9e9",
					"color": "#e9e9e9",
					"alpha": 0.8,
					"selectable": true,
					"balloonText": "[[customData]]",
				},

				"balloon": {
					"horizontalPadding": 15,
					"verticalPadding": 15,
					"textAlign": 'left',
					"fillAlpha": 1,
					"fillColor": "#FFFFFF",
					"adjustBorderColor": true,
					"borderColor": "#FFFFFF"
				},

				"export": {
					"enabled": false
				},

				"creditsPosition": "bottom-left"
			});

			map.addListener('clickMapObject', function (event) {
				addRegion(event.mapObject.id, false);
				rebuildDescriptions();

				// var allcountries = "";
				// $("#chart-map svg path").each(function(){
				//     if($(this).attr('class') !== undefined)
				//         if($(this).attr('class').includes('amcharts-map-area') && !$(this).attr('class').includes('amcharts-map-area-unlisted'))
				//             allcountries += $(this).attr('class') + ' | ' + $(this).attr('aria-label') + "\n";
				// });
				// console.log(allcountries);
			});

			return map;
		}

	});
}(jQuery));
